import { render, staticRenderFns } from "./RelatorioPacientes.vue?vue&type=template&id=4f5146b9"
import script from "./RelatorioPacientes.vue?vue&type=script&lang=js"
export * from "./RelatorioPacientes.vue?vue&type=script&lang=js"
import style0 from "./RelatorioPacientes.vue?vue&type=style&index=0&id=4f5146b9&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports